// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"af20ea876904a0b2107e","293":"dc0c1efb8730d6920102","518":"0e51157682afda106519","779":"603c7e4e80443d31a4e7"}[chunkId] + ".js";
};